import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const AdminRoute = ({isAdmin, path, component }) => {

	if (isAdmin) {
		return <Route exact path={path} component={component} />;
	} else if(window.location.pathname === path){
		return <Redirect exact to={'/dashboard/personas'}/>
	}
	return null
};

export default AdminRoute


// WEBPACK FOOTER //
// ./src/components/AdminRoute.js